if (!customElements.get('rok-door-configurator')) {
  customElements.define('rok-door-configurator', class extends HTMLElement {
    async connectedCallback() {
      this.controller = new AbortController();
      this.root = this.closest('section') || this.closest('.shopify-section');
      if (!this.root) return;
      this.root.classList.add('rok-door-page');
      this.picker = this.root.querySelector('variant-options');
      this.familyArea = this.querySelector('[data-door-families]');
      const finishGroup = Array.from(this.picker?.querySelectorAll('.wt-product__option') || []).find(g => /finish|color/i.test(g.querySelector('input')?.name || ''));
      if (finishGroup && this.familyArea) finishGroup.after(this.familyArea);
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(value / 100);
      this.customerPrices = JSON.parse(this.querySelector('[data-customer-selector-prices]')?.textContent || '{}');
      this.onChange = () => this.decorate();
      this.root.addEventListener('variantChangeEnd', this.onChange);
      this.decorate();
      try {
        const response = await fetch(this.dataset.catalog, {signal:this.controller.signal});
        if (!response.ok) return;
        const catalog = await response.json();
        this.family = catalog.families[catalog.handles[this.dataset.handle]] || [];
        this.current = this.family.find(p => p.handle === this.dataset.handle);
        if (!this.current) return;
        this.products = new Map();
        await Promise.all(this.family.map(async item => {
          try {
            const url = (window.Shopify?.routes?.root || '/') + 'products/' + item.handle + '.js';
            const res = await fetch(url, {signal:this.controller.signal});
            if (res.ok) {
              const product = await res.json();
              const priceURL = new URL((window.Shopify?.routes?.root || '/') + 'products/' + item.handle, location.origin);
              priceURL.searchParams.set('section_id', 'rok-selector-prices');
              const priceResponse = await fetch(priceURL, {signal:this.controller.signal});
              if (!priceResponse.ok) return;
              const priceDocument = new DOMParser().parseFromString(await priceResponse.text(), 'text/html');
              const prices = JSON.parse(priceDocument.querySelector('[data-customer-selector-prices]')?.textContent || '{}');
              product.variants.forEach(variant => { if (prices[variant.id] != null) variant.price = prices[variant.id]; });
              product.price = Math.min(...product.variants.map(variant => variant.price));
              this.products.set(item.handle, product);
            }
          } catch (error) { if (error.name !== 'AbortError') return; }
        }));
        if (this.isConnected) this.renderFamilies();
      } catch (error) { if (error.name !== 'AbortError') return; }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.root?.removeEventListener('variantChangeEnd', this.onChange);
    }
    variants() {
      try { return JSON.parse(this.picker?.querySelector('script[type="application/json"]')?.textContent || '[]'); } catch { return []; }
    }
    selected() {
      return Array.from(this.picker?.querySelectorAll('.wt-product__option') || []).map(group => group.querySelector('input:checked')?.value);
    }
    decorate() {
      if (!this.picker) return;
      const variants = this.variants(), selected = this.selected();
      Array.from(this.picker.querySelectorAll('.wt-product__option')).forEach((group, index) => {
        const list = group.querySelector('ul');
        if (!list) return;
        list.classList.add('rok-door-choice-list');
        const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
        const finish = /finish|color/i.test(inputs[0]?.name || '');
        list.classList.toggle('rok-door-finish-list', finish);
        inputs.forEach(input => {
          input.tabIndex = 0;
          const label = document.getElementById(input.id)?.nextElementSibling;
          if (!label || label.tagName !== 'LABEL') return;
          label.tabIndex = -1;
          const candidates = variants.filter(v => v.options[index] === input.value);
          const exact = candidates.find(v => v.options.every((value, i) => i === index || value === selected[i]));
          const candidate = exact || candidates[0];
          const price = exact ? (this.customerPrices[exact.id] ?? exact.price) : Math.min(...candidates.map(v => this.customerPrices[v.id] ?? v.price));
          const image = candidate?.featured_image?.src;
          const signature = [input.value, price, image || '', !!exact].join('|');
          if (label.dataset.doorSignature === signature) return;
          label.dataset.doorSignature = signature;
          label.replaceChildren();
          if (image) { const img = document.createElement('img'); img.src = image; img.alt = ''; img.loading = 'lazy'; label.append(img); }
          const copy = document.createElement('span'); copy.className = 'rok-door-card-copy';
          const name = document.createElement('span'); name.textContent = input.value; copy.append(name);
          if (Number.isFinite(price)) { const small = document.createElement('span'); small.className = 'rok-door-card-price'; small.textContent = (exact ? '' : this.dataset.from + ' ') + this.money(price); copy.append(small); }
          label.append(copy);
        });
      });
      if (this.current) this.renderFamilies();
    }
    renderFamilies() {
      const area = this.familyArea;
      if (!area || !this.current) return;
      area.replaceChildren();
      for (const [key, title] of [['configuration',this.dataset.configuration],['function',this.dataset.function],['rosette',this.dataset.rosette]]) {
        const siblings = this.family.filter(p => ['configuration','function','rosette'].every(k => k === key || p[k] === this.current[k]));
        if (new Set(siblings.map(p => p[key])).size < 2) continue;
        const field = document.createElement('fieldset'); field.className = 'rok-door-family-group';
        const legend = document.createElement('legend'); legend.textContent = title; field.append(legend);
        const grid = document.createElement('div'); grid.className = 'rok-door-family-grid'; field.append(grid);
        for (const item of siblings) {
          const product = this.products.get(item.handle);
          const link = document.createElement('a');
          const url = new URL((window.Shopify?.routes?.root || '/') + 'products/' + item.handle, location.origin);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          const selected = this.selected();
          const optionNames = Array.from(this.picker?.querySelectorAll('.wt-product__option') || []).map(g => g.querySelector('input')?.name);
          const match = product?.variants?.find(v => product.options.every((o,i) => {const position = optionNames.indexOf(typeof o === 'string' ? o : o.name);return position < 0 || v.options[i] === selected[position];}));
          if (match) url.searchParams.set('variant',match.id);
          link.href = url.href;
          if (item.handle === this.dataset.handle) link.setAttribute('aria-current','page');
          const picture = match?.featured_image?.src;
          if (picture) {const image = document.createElement('img');image.src = picture;image.alt = '';image.loading = 'lazy';link.append(image);}
          const copy = document.createElement('span');copy.className = 'rok-door-card-copy';
          const name = document.createElement('span');name.textContent = item[key];copy.append(name);
          if (product) {const price = document.createElement('span');price.className = 'rok-door-card-price';price.textContent = (match ? '' : this.dataset.from + ' ') + this.money(match?.price ?? product.price);copy.append(price);}
          link.append(copy);grid.append(link);
        }
        area.append(field);
      }
    }
  });
}
